module.exports = __webpack_public_path__ + "img/地图.6a1ff695.svg";